// Feature Flag Service for controlling feature rollouts
interface FeatureFlags {
  brokerDashboardV2: boolean;
  transactionAIMessaging: boolean;
  enhancedActivityFeed: boolean;
  aiAdoptionScoreboard: boolean;
}

class FeatureFlagService {
  private flags: FeatureFlags = {
    brokerDashboardV2: false, // Set to true to enable new dashboard
    transactionAIMessaging: true,
    enhancedActivityFeed: true,
    aiAdoptionScoreboard: false
  };

  // Check if a feature is enabled
  isEnabled(feature: keyof FeatureFlags): boolean {
    // Check localStorage for override
    const override = localStorage.getItem(`feature_${feature}`);
    if (override !== null) {
      return override === 'true';
    }
    
    // Check URL params for testing
    const urlParams = new URLSearchParams(window.location.search);
    const urlOverride = urlParams.get(`feature_${feature}`);
    if (urlOverride !== null) {
      return urlOverride === 'true';
    }
    
    // Return default flag value
    return this.flags[feature];
  }

  // Enable a feature (for testing)
  enable(feature: keyof FeatureFlags): void {
    localStorage.setItem(`feature_${feature}`, 'true');
  }

  // Disable a feature (for testing)
  disable(feature: keyof FeatureFlags): void {
    localStorage.setItem(`feature_${feature}`, 'false');
  }

  // Reset to defaults
  reset(feature: keyof FeatureFlags): void {
    localStorage.removeItem(`feature_${feature}`);
  }

  // Get all flags
  getAllFlags(): FeatureFlags {
    const result: any = {};
    Object.keys(this.flags).forEach((key) => {
      result[key] = this.isEnabled(key as keyof FeatureFlags);
    });
    return result;
  }

  // Check if user is in test group (for A/B testing)
  isInTestGroup(percentage: number = 50): boolean {
    const userId = localStorage.getItem('user_id') || '';
    const hash = this.hashCode(userId);
    return (hash % 100) < percentage;
  }

  // Simple hash function for user ID
  private hashCode(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash);
  }
}

export default new FeatureFlagService();